var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "login",
      on: {
        keyup: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          return _vm.login.apply(null, arguments)
        },
      },
    },
    [
      _c("h2", [_vm._v(_vm._s(_vm.$t("auth.welcome")))]),
      _c(
        "form",
        {
          ref: "loginForm",
          attrs: {
            method: "post",
            action: "/auth/login",
            name: "login",
            model: _vm.loginForm,
            rules: _vm.rules,
          },
        },
        [
          _c("input", {
            staticStyle: { display: "none" },
            attrs: {
              type: "text",
              id: "email",
              autocomplete: "username email",
            },
          }),
          _c("input", {
            staticStyle: { display: "none" },
            attrs: {
              type: "password",
              id: "password",
              autocomplete: "current-password",
            },
          }),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "input-group" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.loginForm.username,
                    expression: "loginForm.username",
                  },
                ],
                attrs: {
                  type: "text",
                  id: "email_display",
                  placeholder: _vm.$t("auth.email"),
                  autocomplete: "off",
                  required: "required",
                  onkeyup: "value=value.replace(/\\s/g,'')",
                  onkeydown: "value=value.replace(/\\s/g,'')",
                },
                domProps: { value: _vm.loginForm.username },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.loginForm, "username", $event.target.value)
                  },
                },
              }),
              _c("i", { staticClass: "bar" }),
            ]),
          ]),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "input-group" }, [
              (_vm.isOpen ? "text" : "password") === "checkbox"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.loginForm.password,
                        expression: "loginForm.password",
                      },
                    ],
                    attrs: {
                      id: "password_display",
                      placeholder: _vm.$t("auth.password"),
                      autocomplete: "off",
                      required: "required",
                      onkeyup: "value=value.replace(/\\s/g,'')",
                      onkeydown: "value=value.replace(/\\s/g,'')",
                      type: "checkbox",
                    },
                    domProps: {
                      checked: Array.isArray(_vm.loginForm.password)
                        ? _vm._i(_vm.loginForm.password, null) > -1
                        : _vm.loginForm.password,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.loginForm.password,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.loginForm,
                                "password",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.loginForm,
                                "password",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.loginForm, "password", $$c)
                        }
                      },
                    },
                  })
                : (_vm.isOpen ? "text" : "password") === "radio"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.loginForm.password,
                        expression: "loginForm.password",
                      },
                    ],
                    attrs: {
                      id: "password_display",
                      placeholder: _vm.$t("auth.password"),
                      autocomplete: "off",
                      required: "required",
                      onkeyup: "value=value.replace(/\\s/g,'')",
                      onkeydown: "value=value.replace(/\\s/g,'')",
                      type: "radio",
                    },
                    domProps: { checked: _vm._q(_vm.loginForm.password, null) },
                    on: {
                      change: function ($event) {
                        return _vm.$set(_vm.loginForm, "password", null)
                      },
                    },
                  })
                : _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.loginForm.password,
                        expression: "loginForm.password",
                      },
                    ],
                    attrs: {
                      id: "password_display",
                      placeholder: _vm.$t("auth.password"),
                      autocomplete: "off",
                      required: "required",
                      onkeyup: "value=value.replace(/\\s/g,'')",
                      onkeydown: "value=value.replace(/\\s/g,'')",
                      type: _vm.isOpen ? "text" : "password",
                    },
                    domProps: { value: _vm.loginForm.password },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.loginForm, "password", $event.target.value)
                      },
                    },
                  }),
              _c("i", { staticClass: "bar" }),
              _c("div", { staticClass: "eye-password" }, [
                !_vm.isOpen
                  ? _c("img", {
                      attrs: { src: _vm.closeEye, alt: "" },
                      on: {
                        click: () => {
                          _vm.isOpen = true
                        },
                      },
                    })
                  : _vm._e(),
                _vm.isOpen
                  ? _c("img", {
                      attrs: { src: _vm.openEye, alt: "" },
                      on: {
                        click: () => {
                          _vm.isOpen = false
                        },
                      },
                    })
                  : _vm._e(),
              ]),
            ]),
          ]),
          _c("div", { attrs: { id: "g-recaptcha-container" } }),
          _vm.verified && _vm.googleRecaptchaFlag
            ? _c("p", { staticClass: "g-error" }, [
                _vm._v(_vm._s(_vm.$t("auth.missingRecaptcha"))),
              ])
            : _vm._e(),
          _c("div", { staticClass: "forget-password" }, [
            _c("span", { on: { click: _vm.forgetPassword } }, [
              _vm._v(_vm._s(_vm.$t("forgetPassword"))),
            ]),
          ]),
          _c(
            "div",
            {
              staticClass:
                "d-flex align--center justify--space-between justify-center",
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  class: { loading: _vm.isLoading },
                  attrs: {
                    type: "button",
                    id: "login",
                    disabled: _vm.isLoading,
                  },
                  on: { click: _vm.submitForm },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.isLoading ? "" : _vm.$t("auth.login")) +
                      "\n        "
                  ),
                  _vm.isLoading
                    ? _c("Spinner", { attrs: { size: "small" } })
                    : _vm._e(),
                  _vm.isLoading
                    ? _c("span", { staticClass: "spinner-text" }, [
                        _vm._v(_vm._s(_vm.$t("loading"))),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }